












































import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";
import moduleStore from "./store/index";
import { Toast } from "vant";

@Component({
  components: {},
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class indexPage extends Vue {
  info: any = {};
  submitId;
  formData = {
    deliveryName: "",
    deliveryPhone: "",
    deliveryAddress: "",
    email: "",
  };
  subDis = true;
  mounted() {
    this.submitId = this.$route.query.submitId;
    this.info = JSON.parse(this.$route.query.info as string);
    this.formData = {
      deliveryName: this.info.deliveryName,
      deliveryPhone: this.info.deliveryPhone,
      deliveryAddress: this.info.deliveryAddress,
      email: this.info.email,
    };
  }
  @Watch("formData", { deep: true, immediate: true })
  onChildChanged(val: string, oldVal: string) {
    this.validate();
  }
  async validate() {
    let arr = [];
    if (this.info.invoiceLine != "p") {
      // 专用发票
      arr = ["email", "deliveryName", "deliveryPhone", "deliveryAddress"];
    } else {
      // 个人
      arr = ["email"];
    }
    const arrFilter = arr
      .map((vo) => {
        return this.formData[vo];
      })
      .filter((vo) => vo);
    this.subDis = arrFilter.length == arr.length ? false : true;
  }
  async submit() {
    const isUpdate =
      (this.info.invoiceLine == "p" &&
        this.formData.email != this.info.email) ||
      (this.info.invoiceLine != "p" &&
        (this.formData.email != this.info.email ||
          this.formData.deliveryName != this.info.deliveryName ||
          this.formData.deliveryPhone != this.info.deliveryPhone ||
          this.formData.deliveryAddress != this.info.deliveryAddress));
    try {
      this.subDis = true;
      if (isUpdate) {
        await (this as any).submitInvoiceUpdate({
          submitId: this.submitId,
          deliveryName: this.formData.deliveryName,
          deliveryPhone: this.formData.deliveryPhone,
          deliveryAddress: this.formData.deliveryAddress,
          email: this.formData.email,
        });
      }
      const res = await (this as any).reSendInvoice({
        submitId: this.submitId,
      });
      if (res.code == 200) {
        Toast({
          type: "success",
          message: "重发成功",
        });
        this.$router.push(
          `/order/success?invoiceLine=${this.info.invoiceLine == 'p'?0:1}&merchant=${res.data.mchIdKind}`
        );
      } else Toast({ type: "fail", message: res.message });
      this.subDis = false;
    } catch (err) {
      this.subDis = false;
    }
  }
}
